/* eslint-disable import/no-extraneous-dependencies */
import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from 'ra-language-english';

const translations = {
	en: {
		...en,
		ra: {
			...en.ra,
			sort: {
				...en.ra.sort,
				sort_by: 'упорядочить по %{field} %{order}',
				ASC: 'по возрастанию',
				DESC: 'по убыванию',
			},
		},
		resources: {
			Promotion: {
				name: 'Акция |||| Акции',
				fields: {
					startDate: 'Дата начала',
					finishDate: 'Дата окончания',
					offer: { short: 'Краткое описание' },
					business: { id: 'Партнер' },
				},
			},
			UserProfile: {
				name: 'Член ППО |||| Члены ППО',
				fields: {
					lastName: 'Фамилия',
					firstName: 'Имя',
					secondName: 'Отчество',
					phone: 'Телефон',
					card: { id: 'Номер карты' },
					updatedAt: 'Дата изменения',
				},
			},
		},
	},
};

export const i18nProvider = polyglotI18nProvider(
	(locale) => translations[locale],
	'en', // default locale
	[
		{ locale: 'en', name: 'English' },
	],
);
